import { CATEGORY_DOWNLOAD_URL } from "../../helpers/api.routes";
import { requests } from "../../helpers/api.services";

export const AdminCategoryDownloadService = {
  getAll: (params: any) => requests.get(`${CATEGORY_DOWNLOAD_URL}`, params),
  create: (params: any) =>
    requests.post(`${CATEGORY_DOWNLOAD_URL}`, params, true),
  getSingle: (id: number) => requests.get(`${CATEGORY_DOWNLOAD_URL}/${id}`),
  update: (params: any, id: number) =>
    requests.post(`${CATEGORY_DOWNLOAD_URL}/${id}`, params, true),
  updatePosition: (params: any) =>
    requests.patch(`${CATEGORY_DOWNLOAD_URL}`, params),
  delete: (id: number) => requests.delete(`${CATEGORY_DOWNLOAD_URL}/${id}`),
};
